import React from 'react';
import EventsContainer from './EventsContainer';
import './WeekView.css';

export default class WeekView extends React.Component {
	constructor(props) {
		super(props);
		this.now = new Date();
		this.state = { date: this.now, selected: this.props.selected || 'Today' };
		this.changeDate = this.changeDate.bind(this);

    this.weekdays = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

    const days = ['Today'];
    for (let i = 1; i < 7; i++) {
      const day = new Date(this.now);
      day.setDate(day.getDate() + i);
      days.push(this.weekdays[day.getDay()]);
    }
    this.days = days;
	}

	changeDate(daysAhead) {
		const date = new Date(this.now);
		date.setDate(date.getDate() + daysAhead);

    const oldHash = document.location.hash;
    const options = { weekday: 'long'};
    const dayStr = new Intl.DateTimeFormat('en-US', options).format(date);
    document.location.hash = oldHash.replace(/\/.*$/, '/' + dayStr);

		this.setState({ date, selected: this.days[daysAhead] });
	}

	render() {
    const endDate = new Date(this.state.date);
    endDate.setDate(endDate.getDate() + 1);

		return(
      <div className="week-view">
        <div className="week-navigation">
          {this.days.map((weekday, i) => {
            return(
              <button 
              className={`item ${weekday === this.state.selected ? 'selected' : ''}`}
              key={weekday}
              type="button"
              onClick={() => this.changeDate(i)}
              >
                {weekday}
              </button>
            );
          })}
        </div>
  			<EventsContainer
  				startDate={this.state.date}
  				endDate={endDate}
  				perPage={15}
          showEnded
          noBackDate
          mode={this.props.mode}
        /> 
      </div>
		);
	}
}